import { useContext } from 'react';

import { TimeseriesPointsDisplayContext } from '../context/TimeseriesPointsDisplayContext.js';

export const usePointsDisplay = () =>
  useContext(TimeseriesPointsDisplayContext);
